import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=05a4869e&"
import script from "./TextTooltip.vue?vue&type=script&lang=js&"
export * from "./TextTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports